export const getBalancesDueOnInactiveLoan = (
  outstandingBalance: number,
  escrowed: boolean,
  balances: { escrowBalance: number; advancesPrincipalOutstandingIncludingDeferred?: number | null },
): {
  unpaidPrincipalBalance: number;
  escrowAdvance?: number;
  unpaidAdvance: number;
} => ({
  unpaidPrincipalBalance: outstandingBalance,
  escrowAdvance: escrowed ? (balances.escrowBalance < 0 ? Math.abs(balances.escrowBalance) : 0) : undefined,
  unpaidAdvance: balances.advancesPrincipalOutstandingIncludingDeferred ?? 0,
});
